import { createBrowserRouter } from "react-router-dom";
import { routes } from "./routes";
import { strings } from "../localization";

export const router = createBrowserRouter(routes, { basename: strings.basePath });
